import { MapTemplateIcon } from "@/assets/icons";

interface SectionProps {
  title: string;
  count?: number;
}

const Skeleton = ({ width = "w-full", height = "h-6" }) => (
  <div
    className={`${height} ${width} bg-whisper rounded animate-pulse`}
    data-testid="skeleton"
  />
);

const SkeletonGroup = ({ count = 4 }) => (
  <>
    {Array.from({ length: count }).map(() => {
      const uniqueKey = crypto.randomUUID();
      return <Skeleton key={uniqueKey} />;
    })}
  </>
);

const Section = ({ title, count = 4 }: SectionProps) => (
  <div
    className="space-y-2"
    data-testid={`section-${title.toLowerCase().replace(/\s/g, "-")}`}
  >
    <p className="font-semibold text-black">{title}</p>
    <SkeletonGroup count={count} />
  </div>
);

export default function LoadingShimmerTemplate() {
  return (
    <div data-testid="loading-shimmer-template">
      <div
        className="flex items-center justify-between w-full bg-teal-50 px-5 py-5 rounded-xl h-40"
        data-testid="header-section"
      >
        <Skeleton width="w-1/2" />
        <div data-testid="map-icon">
          <MapTemplateIcon />
        </div>
      </div>
      <div
        className="grid grid-cols-1 gap-6 md:grid-cols-2"
        data-testid="content-grid"
      >
        <div className="space-y-6" data-testid="left-column">
          <Section title="Objective" />
          <Section title="Problem Statement" />
          <Section title="Sample Configuration Result" />
        </div>
        <div data-testid="right-column">
          <div
            className="font-semibold text-txtHeading mb-2"
            data-testid="configuration-title"
          >
            Configuration
          </div>
          <div className="space-y-2" data-testid="configuration-skeletons">
            <SkeletonGroup count={15} />
          </div>
          <div className="h-5 shrink-0 w-full" />
        </div>
      </div>
    </div>
  );
}
